import settings from 'src/config/settings'

export const DOWNLOAD_APL_DOCUMENT_ENDPOINT = `${settings.httpsServices.onboarding}/api/v0/apl/download-tc-sdc` // :id should be used as url parameter
